<!-- customer-contact-management.component.html -->
<div class="mx-lg p-6">
  <div class="p-6">

    <!-- Header -->
    <div class="mb-6">
      <div class="flex justify-between items-center">
        <div>
          <h2 class="text-2xl font-bold text-gray-900">Manage Contact Persons</h2>
          <p class="text-gray-600 mt-1">Customer: {{ customerName() }}</p>
        </div>
        <button (click)="goBack()" class="button-white">
          ← Back to Customer
        </button>
      </div>
    </div>

    <div class="flex py-4 border-b"></div>

    <!-- Existing Contact Persons Section -->
    <div class="mb-6 mt-6">
      <h3 class="text-lg font-semibold text-gray-900 mb-4">Existing Contact Persons</h3>

      @if (existingContacts().length > 0) {
      <div class="space-y-4">
        @for (contact of existingContacts(); track contact.contactPersonId) {
        <div class="border border-gray-300 rounded-lg p-4 bg-white">
          <div class="grid lg:grid-cols-4 md:grid-cols-2 xs:grid-cols-1 gap-4">

            <div>
              <label class="text-sm font-medium text-gray-700">Contact Person Name</label>
              <p class="mt-1 text-gray-900">{{ contact.contactPersonName }}</p>
            </div>

            <div>
              <label class="text-sm font-medium text-gray-700">Designation</label>
              <p class="mt-1 text-gray-900">{{ contact.contactPersonDesignation || '-' }}</p>
            </div>

            <div>
              <label class="text-sm font-medium text-gray-700">Office Phone</label>
              <p class="mt-1 text-gray-900">{{ contact.contactPersonOfficePhoneNumber || '-' }}</p>
            </div>

            <div>
              <label class="text-sm font-medium text-gray-700">Mobile Number</label>
              <p class="mt-1 text-gray-900">{{ contact.contactPersonMobileNumber || '-' }}</p>
            </div>

            <div>
              <label class="text-sm font-medium text-gray-700">Email</label>
              <p class="mt-1 text-gray-900">{{ contact.contactPersonEmail || '-' }}</p>
            </div>
          </div>
                        <!-- Status Toggle -->
              <div class="mt-6 flex items-center justify-between">
                @if (!contact.status) {
                  <p class="text-xs text-red-500">
                    Contact Person is inactive. Toggle to enable.
                  </p>
                } @else {
                  <span></span>
                }

                <div class="flex items-center gap-3">
                  <span class="text-sm font-medium text-gray-700">
                    {{ contact.status ? 'Active' : 'Inactive' }}
                  </span>
                  <label class="relative inline-flex items-center cursor-pointer">
                    <input 
                      type="checkbox" 
                      [checked]="contact.status"
                      (change)="toggleContactStatus(contact)"
                      class="sr-only peer">
                    <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-green-600"></div>
                  </label>
                </div>
              </div>


        </div>
        }
      </div>
      } @else {
      <p class="text-gray-500 text-center py-4">No existing contact persons found.</p>
      }
    </div>

    <div class="flex py-4 border-b"></div>

    <!-- New Contact Persons Section -->
    <div class="mb-6 mt-6">
      <div class="flex justify-between items-center mb-4">
        <h3 class="text-lg font-semibold text-gray-900">Add New Contact Persons</h3>
        <button (click)="addNewContact()" type="button" class="button-blue">
          Add Contact Person
        </button>
      </div>

      @if (newContacts().length > 0) {
      <div class="space-y-4">
        @for (contact of newContacts(); track $index) {
        <div class="border border-gray-200 rounded-lg p-4 bg-green-50">
          <div class="flex justify-between items-center mb-3">
            <h4 class="font-medium text-gray-700">New Contact Person {{ $index + 1 }}</h4>
            <button (click)="removeNewContact($index)" type="button"
              class="text-red-600 hover:text-red-800 text-sm font-medium">
              Remove
            </button>
          </div>

          <div class="grid lg:grid-cols-4 md:grid-cols-2 xs:grid-cols-1 gap-4">

            <!-- Title -->
            <app-search-person-title [disabled]=false [resetTrigger]="resetSearchTrigger()"
              [PersonTitleInput]="contact.title" (selectedPersonTitle)="onNewContactTitleSelected($index, $event)">
            </app-search-person-title>

            <!-- Contact Person Name -->
            <div class="relative">
              <input type="text" [id]="'contactPersonName' + $index" class="textField peer" placeholder=" "
                [(ngModel)]="contact.contactPersonName"
                (ngModelChange)="updateNewContactField($index, 'contactPersonName', $event)" required>
              <label class="label" [for]="'contactPersonName' + $index">
                Contact Person Name <span class="text-red-700">*</span>
              </label>
            </div>

            <!-- Designation -->
            <div class="relative">
              <input type="text" [id]="'contactPersonDesignation' + $index" class="textField peer" placeholder=" "
                [(ngModel)]="contact.contactPersonDesignation"
                (ngModelChange)="updateNewContactField($index, 'contactPersonDesignation', $event)">
              <label class="label" [for]="'contactPersonDesignation' + $index">
                Designation
              </label>
            </div>

            <!-- Office Phone Number -->
            <div class="relative">
              <input type="tel" [id]="'contactPersonOfficePhoneNumber' + $index" class="textField peer" placeholder=" "
                [(ngModel)]="contact.contactPersonOfficePhoneNumber"
                (ngModelChange)="updateNewContactField($index, 'contactPersonOfficePhoneNumber', $event)"
                phoneNumberOnly>
              <label class="label" [for]="'contactPersonOfficePhoneNumber' + $index">Office Phone Number</label>
            </div>

            <!-- Mobile Number -->
            <div class="relative">
              <input type="tel" [id]="'contactPersonMobileNumber' + $index" class="textField peer" placeholder=" "
                [(ngModel)]="contact.contactPersonMobileNumber"
                (ngModelChange)="updateNewContactField($index, 'contactPersonMobileNumber', $event)" phoneNumberOnly>
              <label class="label" [for]="'contactPersonMobileNumber' + $index">Mobile Number</label>
            </div>

            <!-- Email -->
            <div class="relative">
              <input type="email" [id]="'contactPersonEmail' + $index" class="textField peer" placeholder=" "
                [(ngModel)]="contact.contactPersonEmail"
                (ngModelChange)="updateNewContactField($index, 'contactPersonEmail', $event)">
              <label class="label" [for]="'contactPersonEmail' + $index">
                Email
              </label>
            </div>
          </div>
        </div>
        }
      </div>
      } @else {
      <p class="text-gray-500 text-center py-4">No new contact persons added. Click "Add Contact Person" to create one.
      </p>
      }
    </div>

    <!-- Action Buttons -->
    <div class="flex justify-end space-x-3 mt-6">
      <button (click)="goBack()" class="button-white">
        Cancel
      </button>
      <button (click)="saveNewContacts()" [disabled]="isValidNewContacts()" class="button-blue">
        Save New Contact Persons
      </button>
    </div>
  </div>
</div>